module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"17\" height=\"8\" viewBox=\"0 0 17 8\"><g><g transform=\"rotate(-90 8.5 4)\"><path fill=\"currentColor\" d=\"M4.636 11.157a.5.5 0 0 0 .728.686l7-7.44a.5.5 0 0 0 .003-.682l-7-7.56a.5.5 0 0 0-.734.679l6.683 7.218z\"/></g></g></svg>"


//////////////////
// WEBPACK FOOTER
// ./src/resources/icons/icon_chevron_up.svg
// module id = 331
// module chunks = 0